import React, { Component } from 'react';
import RkNav from './components/common/RkNav';
import Footer from './components/common/Footer';
import SystemPage from './components/system/SystemsPage';
import HomePage from './components/home/HomePage';
import ServicesPage from './components/service/ServicesPage';
import AboutPage from './components/about/AboutPage';
import ManageSystemPage from './components/system/ManageSystemPage';
import ContactPage from './components/contact/ContactPage';
import { Switch, Route } from 'react-router-dom';
import PageNotFound from './components/common/PageNotFound';
import LoginPage from './components/login/LoginPage';
import { ToastContainer } from 'react-toastify';
import SitesPage from './components/site/SitesPage';
import ManageSitePage from './components/site/ManageSitePage';
import WaterReadingPage from './components/reading/water/WaterReadingPage';
import WasteReadingPage from './components/reading/waste/WasteReadingPage';
import DailyLogPage from './components/daily-log/DailyLogPage';
import DailyLogEntryPage from './components/daily-log/DailyLogEntryPage';
import ManageDailyLogEntryPage from './components/daily-log/ManageDailyLogEntryPage';
import Dashboard from './components/common/Dashboard';
import RepairLogPage from './components/repair-log/RepairLogPage';
import RepairLogEntryPage from './components/repair-log/RepairLogEntryPage';
import ManageRepairLogEntryPage from './components/repair-log/ManageRepairLogEntryPage';
import TimeCardPage from './components/timecard/TimeCardPage';
import TimeCardEntryPage from './components/timecard/TimeCardEntryPage';
import ManageTimeCardEntryPage from './components/timecard/ManageTimeCardEntryPage';
import UserPage from './components/user/UserPage';
import ManagerUserPage from './components/user/ManagerUserPage';
import ReportsPage from './components/reports/ReportsPage';
import PrivateRoute from './components/common/PrivateRoute';
import DashNav from './components/common/DashNav';
import TimeAdminPage from './components/timecard/TimeAdminPage';
import ManagePayPage from './components/pay/ManagePayPage';
import ChangePasswordPage from './components/login/ChangePasswordPage';
import ManageWaterReadingPage from './components/reading/water/ManageWaterReadingPage';
import ManageWasteReadingPage from './components/reading/waste/ManageWasteReadingPage';

class App extends Component {
  render() {
    return (
      <div>
        <RkNav />
        <DashNav />
        <ToastContainer autoClose={1000} hideProgressBar={false} />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/services" component={ServicesPage} />
          <Route exact path="/contact" component={ContactPage} />
          <Route exact path="/login" component={LoginPage} />

          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            exact
            path={'/change-password'}
            component={ChangePasswordPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            exact
            path="/dashboard"
            component={Dashboard}
          />

          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            exact
            path={'/time-cards'}
            component={TimeCardPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            path={'/time-cards/:id'}
            component={TimeCardEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            path={'/time-card-entries/:id'}
            component={ManageTimeCardEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_CONTRACTOR'}
            path={'/time-card-entry'}
            component={ManageTimeCardEntryPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/daily-logs'}
            component={DailyLogPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/daily-log/:id'}
            component={DailyLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/daily-log-entries/:id'}
            component={ManageDailyLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/daily-log/:logId/daily-log-entry/'}
            component={ManageDailyLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/daily-log-entry'}
            component={ManageDailyLogEntryPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/repair-logs'}
            component={RepairLogPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/repair-log/:id'}
            component={RepairLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/repair-log/:logId/repair-log-entries/:id'}
            component={ManageRepairLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/repair-log-entries/:id'}
            component={ManageRepairLogEntryPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/repair-log/:logId/repair-log-entry'}
            component={ManageRepairLogEntryPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/water'}
            component={WaterReadingPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_EMPLOYEE'}
            exact
            path={'/wastewater'}
            component={WasteReadingPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/water/:id'}
            component={ManageWaterReadingPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/wastewater/:id'}
            component={ManageWasteReadingPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/reports'}
            component={ReportsPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/time-admin'}
            component={TimeAdminPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/pay'}
            component={ManagePayPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path="/systems"
            component={SystemPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path="/systems/:id"
            component={ManageSystemPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path={'/system'}
            component={ManageSystemPage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path="/sites"
            component={SitesPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path="/sites/:id"
            component={ManageSitePage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path={'/site'}
            component={ManageSitePage}
          />

          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            exact
            path={'/users'}
            component={UserPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path={'/users/:id'}
            component={ManagerUserPage}
          />
          <PrivateRoute
            requiredRole={'ROLE_MANAGER'}
            path={'/user'}
            component={ManagerUserPage}
          />

          <Route component={PageNotFound} />
        </Switch>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js